import { useState } from 'react';
import styled from 'styled-components';
import { AddNew16, Delete } from 'ui/icons';
import { GhostSuccessButton, GhostButton } from 'ui/button';
import { spacing } from 'ui/theme';
import { InAppContentDefinition, PushContentDefinition } from 'modules/graphql/types';
import { AceEditor } from 'modules/aceEditor';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';

import { SETTINGS_DISPLAY_CONTENT } from './constants';

const RawDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  align-items: flex-start;
`;

type ContentDefinition = InAppContentDefinition | PushContentDefinition;

export const RawEditField = () => {
  const { liveTemplate, setCurrentMediumFields } = useEditableFieldsContext();
  const data = (liveTemplate?.mediumData || {}) as ContentDefinition;
  const [rawDataActive, setRawDataActive] = useState(
    data.payload !== '{}' && data.payload !== null,
  );

  const handleRemoveRawData = () => {
    setRawDataActive(false);
    setCurrentMediumFields({ payload: null });
  };

  const handleResetRawData = () => {
    setCurrentMediumFields({ payload: '{}' });
    setRawDataActive(true);
  };

  return (
    <>
      {!rawDataActive ? (
        <GhostSuccessButton onClick={handleResetRawData}>
          <AddNew16 />
          {SETTINGS_DISPLAY_CONTENT.addRawButton}
        </GhostSuccessButton>
      ) : (
        <RawDataWrapper>
          <AceEditor
            editorProps={{
              $blockScrolling: Infinity,
            }}
            height="230px"
            mode="json"
            onChange={(json) => {
              setCurrentMediumFields({ payload: json });
            }}
            value={data.payload ?? '{}'}
            wrapEnabled
          />
          <GhostButton onClick={handleRemoveRawData}>
            <Delete />
            {SETTINGS_DISPLAY_CONTENT.removeRawButton}
          </GhostButton>
        </RawDataWrapper>
      )}
    </>
  );
};
